module.exports = __webpack_public_path__ + "img/GAME_COLORDRAW.38c25dd7.png";